import RecepcionesFletes from "./RecepcionesFletes";

export default RecepcionesFletes;
